import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { firstError, firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import {
  columnDate,
  columnNameLink,
  columnStatus,
  columnTools,
} from '@/constants/fields';
import TableWrapper from '@/components/table/TableWrapper';
import CompactTableHeader from '@/components/table/CompactTableHeader';
import NoRows from '@/components/table/NoRows';
import DatasetStorageErrorRow from '../../components/DatasetStorageErrorRow';
import DataModelReportsTableColumns from './DataModelReportsTableColumns';
import DataModelReportsTableRows from './DataModelReportsTableRows';

const DataModelReportsTable = ({
  category,
  code,
  readStatus,
  readErrors,
  reports,
}) => {
  const intl = useIntl();
  const isLoading = readStatus === states.PENDING;
  const columns = [columnNameLink, columnDate, columnStatus, columnTools];
  const colSpan = columns.length;

  const error = firstError(readErrors);
  const noReports = (reports.length === 0 && !error && readStatus !== states.PENDING);

  return (
    <>
      <TableWrapper className="aridhia-dataset-data-model-reports-table">
        <Table.Header fullWidth>
          <CompactTableHeader
            className="aridhia-data-model-reports-header"
            headerId="dataset.data.datamodel.reports"
            description="dataset.data.datamodel.reports.description"
            isLoading={isLoading}
            numberOfColumns={colSpan}
          >
            <span className="normal">
              <FormattedMessage id="dataset.data.datamodel.reports.description" />
            </span>
          </CompactTableHeader>
          <DataModelReportsTableColumns columns={columns} />
        </Table.Header>
        <Table.Body className={clsx(reports.length >= 6 && 'overflow-scroll')}>
          {error && (
            <DatasetStorageErrorRow
              colSpan={colSpan}
              errorMsg={firstErrorMessage(readErrors) || intl.formatMessage({ id: 'dataset.storage.error' })}
            />
          )}
          <DataModelReportsTableRows category={category} code={code} columns={columns} reports={reports} />
        </Table.Body>
      </TableWrapper>
      {noReports && (<NoRows icon="file" entity="dataset.data.datamodel.reports" />)}
    </>
  );
};

export default DataModelReportsTable;
